import { useScript } from '../../../../../composables/useScript'
import type { GooglePay } from '../../../../../types/google-pay'
import { PaymentError } from '../../../types/PaymentError'

export const GOOGLE_PAY_LIBRARY_URL = 'https://pay.google.com/gp/p/js/pay.js'

/** Load and expose the page-global Google Pay library. */
export function useGooglePayLibrary() {
  const script = useScript(
    {
      src: GOOGLE_PAY_LIBRARY_URL,
      crossorigin: false,
    },
    {
      trigger: 'manual',
      use: () => window.google,
    },
  )

  async function getGooglePayLibrary(): Promise<GooglePay> {
    try {
      const library = await script.load()

      if (!library) {
        throw new PaymentError('Google Pay library not loaded correctly', {
          type: '/errors/payment/unexpected',
        })
      }

      return library
    } catch (error) {
      if (error instanceof PaymentError) {
        throw error
      }

      throw new PaymentError('Google Pay library failed to load', {
        cause: error,
        type: '/errors/payment/network-error',
      })
    }
  }

  return { getGooglePayLibrary }
}
